// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { BootstrapButton, BootstrapInput, BootstrapCheck } from '../../dsl/front';
import { AbstractModuleUi } from '../_abstract/ui';
import { ModuleHeaderUi } from '../_components/ui';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 * @author Rafał Żak <rafal.zak@movecloser.pl>
 */
let RequestAccessModuleUi = class RequestAccessModuleUi extends AbstractModuleUi {
    constructor() {
        super(...arguments);
        /**
         * Message to display
         */
        this.message = '';
        /**
         * Data entered by the User.
         */
        this.formData = {
            name: null,
            surname: null,
            tel: null,
            email: null,
            organization: null,
            title: null,
            vatId: null,
            permissionOne: null,
            permissionTwo: null,
            permissionThree: null,
            permissionFour: null,
            role: null
        };
        this.permissionsSelected = new Set();
        this.selectAllPermissions = false;
    }
    get permissionOneCondition() {
        return Boolean(this.module.content.permissionOne && this.module.content.permissionOneValue);
    }
    get permissionTwoCondition() {
        return Boolean(this.module.content.permissionTwo && this.module.content.permissionTwoValue);
    }
    get permissionThreeCondition() {
        return Boolean(this.module.content.permissionThree && this.module.content.permissionThreeValue);
    }
    get permissionFourCondition() {
        return Boolean(this.module.content.permissionFour && this.module.content.permissionFourValue);
    }
    get isPermission() {
        return this.permissionOneCondition || this.permissionTwoCondition || this.permissionThreeCondition || this.permissionFourCondition;
    }
    get permissionsNumber() {
        let number = 0;
        // think about better solution if permissions will appear as array
        if (this.permissionOneCondition) {
            number++;
        }
        if (this.permissionTwoCondition) {
            number++;
        }
        if (this.permissionThreeCondition) {
            number++;
        }
        if (this.permissionFourCondition) {
            number++;
        }
        return number;
    }
    updatePermission(value, permission) {
        if (value) {
            this.permissionsSelected.add(permission);
        }
        else {
            this.permissionsSelected.delete(permission);
        }
        this.selectAllPermissions = this.permissionsSelected.size === this.permissionsNumber;
    }
    updateAllPermissions(value) {
        this.selectAllPermissions = value;
        // think about better solution if permissions will appear as array
        if (this.selectAllPermissions) {
            if (this.permissionOneCondition) {
                this.formData.permissionOne = true;
                this.permissionsSelected.add('permission-1');
            }
            if (this.permissionTwoCondition) {
                this.formData.permissionTwo = true;
                this.permissionsSelected.add('permission-2');
            }
            if (this.permissionThreeCondition) {
                this.formData.permissionThree = true;
                this.permissionsSelected.add('permission-3');
            }
            if (this.permissionFourCondition) {
                this.formData.permissionFour = true;
                this.permissionsSelected.add('permission-4');
            }
        }
        else {
            if (this.permissionOneCondition) {
                this.formData.permissionOne = false;
                this.permissionsSelected.delete('permission-1');
            }
            if (this.permissionTwoCondition) {
                this.formData.permissionTwo = false;
                this.permissionsSelected.delete('permission-2');
            }
            if (this.permissionThreeCondition) {
                this.formData.permissionThree = false;
                this.permissionsSelected.delete('permission-3');
            }
            if (this.permissionFourCondition) {
                this.formData.permissionFour = false;
                this.permissionsSelected.delete('permission-4');
            }
        }
    }
    /**
     * WARNING! **DO NOT** override this function in client,
     * as this function has direct impact on UI
     */
    submitForm() {
        this.onSubmit(this.module.content.uuid, this.formData, this.module.content.eventName).then(() => {
            this.message = this.$t('modules.RequestAccess.onSuccess').toString();
        }).catch(e => {
            this.message = e.message || this.$t('modules.RequestAccess.onError').toString();
        }).finally(() => {
            this.formData = {
                name: null,
                surname: null,
                tel: null,
                email: null,
                organization: null,
                title: null,
                vatId: null,
                permissionOne: null,
                permissionTwo: null,
                permissionThree: null,
                permissionFour: null,
                role: null
            };
            this.selectAllPermissions = false;
        });
    }
    /**
     * Notice! This function **HAS TO** be overridden in client
     */
    onSubmit(uuid, formData, eventName) {
        return Promise.resolve();
    }
};
RequestAccessModuleUi = __decorate([
    Component({
        name: 'RequestAccessModuleUi',
        components: {
            BootstrapButton,
            BootstrapInput,
            BootstrapCheck,
            ModuleHeaderUi
        },
        template: `
    <section class="request-access-module" :id="module.content.anchor"
             :style="{ background }">
    <div class="container">
      <div class="row">
        <div class="col col-lg-8 offset-lg-2">

          <!-- Heading -->
          <ModuleHeaderUi v-if="module.content.header" :header="module.content.header"/>

          <!-- Form -->
          <form class="row justify-content-center" @submit.prevent="submitForm">
            <div class="col-12 col-sm-9 col-md-8 col-lg-12">
              <!-- Name -->
              <BootstrapInput name="name" :model.sync="formData.name"
                              autocomplete="name" :required="true"
                              :label="$t('_.name')" class="mb-3"/>

              <BootstrapInput name="name" :model.sync="formData.surname"
                              autocomplete="name" :required="true"
                              :label="$t('_.surname')" class="mb-3"/>

              <!-- E-mail address -->
              <BootstrapInput type="email" name="email" :model.sync="formData.email"
                              autocomplete="email" :required="true"
                              :label="$t('_.email-address')" class="mb-3"/>

              <!-- Phone number -->
              <BootstrapInput v-if="module.content.phone" type="tel" name="tel" :model.sync="formData.tel"
                              autocomplete="tel" :required="true"
                              :label="$t('_.phone-number')" class="mb-3"/>

              <!-- Title -->
              <BootstrapInput v-if="module.content.title" name="title" :model.sync="formData.title"
                              autocomplete="title" :required="false"
                              :label="$t('_.title')" class="mb-3"/>

              <!-- Organization -->
              <BootstrapInput v-if="module.content.organization" name="organization" :model.sync="formData.organization"
                              autocomplete="organization" :required="true"
                              :label="$t('_.companyName')" class="mb-3"/>

              <!-- Role -->
              <BootstrapInput v-if="module.content.role" name="organization-title" :model.sync="formData.role"
                              autocomplete="organization-title" :required="true"
                              :label="$t('_.role')" class="mb-3"/>

               <!--VAT -->
              <BootstrapInput v-if="module.content.vatId" name="vatId" :model.sync="formData.vatId"
                              autocomplete="vat-id" :required="false"
                              :label="$t('_.vatId')" class="mb-3"/>

               <!--Permissions -->
              <div class="mb-7">
                <BootstrapCheck
                  v-if="permissionOneCondition"
                  class="text-start"
                  :options="[
                    {
                      label: module.content.permissionOneValue,
                      name: 'permission-1'
                    },
                  ]"
                  name="permission-1"
                  :multiple="true"
                  :required="true"
                  @update:model="updatePermission($event, 'permission-1')"
                  :model.sync="formData.permissionOne"
                />

                <BootstrapCheck
                  v-if="permissionTwoCondition"
                  class="text-start"
                  :options="[
                    {
                      label: module.content.permissionTwoValue,
                      name: 'permission-2'
                    },
                  ]"
                  name="permission-2"
                  :multiple="true"
                  :required="true"
                  @update:model="updatePermission($event, 'permission-2')"
                  :model.sync="formData.permissionTwo"
                />

                <BootstrapCheck
                  v-if="permissionThreeCondition"
                  class="text-start"
                  :options="[
                    {
                      label: module.content.permissionThreeValue,
                      name: 'permission-3'
                    },
                  ]"
                  name="permission-3"
                  :multiple="true"
                  :required="true"
                  @update:model="updatePermission($event, 'permission-3')"
                  :model.sync="formData.permissionThree"
                />

                <BootstrapCheck
                  v-if="permissionFourCondition"
                  class="text-start"
                  :options="[
                    {
                      label: module.content.permissionFourValue,
                      name: 'permission-4'
                    },
                  ]"
                  name="permission-4"
                  :multiple="true"
                  :required="true"
                  @update:model="updatePermission($event, 'permission-4')"
                  :model.sync="formData.permissionFour"
                />

                <BootstrapCheck
                  v-if="isPermission"
                  class="text-start"
                  :options="[
                    {
                      label: $t('_.selectAll'),
                      name: 'permission-all'
                    },
                  ]"
                  name="all-permissions"
                  :multiple="true"
                  :required="false"
                  @update:model="updateAllPermissions"
                  :model="selectAllPermissions"
                />

                <p v-if="isPermission" class="small text-start ms-6">{{ $t('_.requiredFields') }}</p>

              </div>

              <p v-if="message !== ''" class="text-center">{{ message }}</p>

              <!-- "Submit" button -->
              <div class="d-flex justify-content-center fs-medium mt-5 text-left">
                <BootstrapButton type="submit" class="btn-cta">
                  {{ $t('modules.RequestAccess.submit-registration') }}
                </BootstrapButton>
              </div>


              <div class="fs-medium mt-5 text-left"
                   v-if="module.content.additionalInformation"
                   v-html="module.content.additionalInformation"/>
            </div>
          </form>
          <!-- END | Form -->

        </div>
      </div>
    </div>
    </section>
  `
    })
], RequestAccessModuleUi);
export { RequestAccessModuleUi };
